import { __decorate } from "tslib";
import colors from '@/styles/color.scss';
import { Component, Vue } from 'vue-property-decorator';
import { getOtaDetail } from '@blade-sxp/ota-management/api/index';
import OtaDetailList from '@blade-sxp/ota-management/components/ota-detail-list.vue';
let default_1 = class extends Vue {
    taskId = '';
    detailData = {
        deviceStatusView: {},
        taskExecuteStatusView: {},
    };
    colors = colors;
    formatSeconds(value) {
        let theTime = parseInt(value); // 需要转换的时间秒
        let theTime1 = '';
        if (theTime > 24 * 60 * 60) {
            theTime1 = '' + (theTime / (24 * 60 * 60)).toFixed(2) + 'd';
        }
        else if (theTime > 60 * 60) {
            theTime1 = '' + (theTime / (60 * 60)).toFixed(2) + 'h';
        }
        else if (theTime > 60) {
            theTime1 = '' + (theTime / 60).toFixed(2) + 'min';
        }
        else if (theTime > 0) {
            theTime1 = '' + theTime + 's';
        }
        else {
            theTime1 = '-';
        }
        return theTime1;
    }
    getOtaDetail() {
        getOtaDetail(String(this.taskId))
            .then((resp) => {
            this.detailData = {
                ...resp.data.data,
            };
        })
            .catch((err) => {
            this.$message.error(String(err));
        });
    }
    mounted() {
        const query = this.$route.query;
        const { taskId } = query;
        if (taskId) {
            this.taskId = taskId;
            this.getOtaDetail();
        }
    }
};
default_1 = __decorate([
    Component({
        name: 'OtaDetail',
        components: {
            OtaDetailList,
        },
        i18n: {
            messages: {
                'en-us': {
                    unusual: 'unusual',
                    online: 'Online',
                    offline: 'Offline',
                    packageName: 'Package name',
                    packageType: 'Type',
                    packageVersion: 'Version',
                    creatorName: 'Creator',
                    deviceStatus: 'Device Status',
                    normal: 'normal',
                    abnormal: 'abnormal',
                    taskStatus: 'Task Status',
                    success: 'Success',
                    fail: 'Fail',
                    cancel: 'Canceled',
                    toUpdate: 'Pending',
                    waiting: 'Pending',
                    taskExecuteTime: 'Task Execution Time',
                    taskleftSecond: 'Task Remaining Time',
                    taskCreateTime: 'Creation time',
                    liveVideo: 'Video Stream',
                    owningGroup: 'Group',
                    equipmentCategory: 'Main Category',
                    owningSubclass: 'Detailed Category',
                    charactersLimit: 'Input content within 50 characters',
                    toAdd: 'No Record, click to add',
                    deviceType: 'Device Type',
                    updating: 'Updating',
                    deviceGroup: 'Associated Device Group',
                },
                zh: {
                    online: '在线',
                    offline: '离线',
                    unusual: '异常',
                    packageName: '更新包名称',
                    packageType: '更新包类型',
                    packageVersion: '更新包版本',
                    creatorName: '创建人',
                    deviceStatus: '设备状态',
                    normal: '正常',
                    abnormal: '异常',
                    taskStatus: '任务状态',
                    cancel: '取消更新',
                    toUpdate: '待更新',
                    success: '成功',
                    fail: '失败',
                    waiting: '等待执行',
                    taskExecuteTime: '任务执行时间',
                    taskleftSecond: '任务剩余时间',
                    taskCreateTime: '创建任务时间',
                    liveVideo: '实时流视频',
                    owningGroup: '所属设备组',
                    equipmentCategory: '所属设备大类',
                    owningSubclass: '所属设备子类',
                    charactersLimit: '输入内容在50个字符以内',
                    toAdd: '暂无数据点击添加',
                    deviceType: '设备类型',
                    updating: '更新中',
                    deviceGroup: '关联设备组',
                },
            },
        },
    })
], default_1);
export default default_1;
